export enum PatientPayorTypeEnum {
    All = "All",
    Primary = "Primary",
    Secondary = "Secondary",
    Tertiary = "Tertiary",
    RoomAndBoard = "Room & Board",
    PalliativeCare = "Palliative Care",
    Vbid = "Vbid"
}
